{% block sw_product_detail_content_tabs_reviews %}
    {% parent %}
    <sw-tabs-item :route="{ name: 'sw.product.detail.upselling', params: { id: $route.params.id } }" title="Upselling">
        {{ $tc('sw-product.upselling.cardTitleUpselling') }}
    </sw-tabs-item>
{% endblock %}
